import { Anchor } from '@components/Anchor';
import { DataTable } from '@components/Table/DataTable';
import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableContainerProps, TableHead, TableRow } from '@material-ui/core';
import { IVendedor } from '@model/Vendedor';
import { IVendedorMovimentacao, useVendedorMovimentacaoTipoColor } from '@model/VendedorMovimentacao';
import { IVendedorMovimentacaoFilter } from '@services/VendedorMovimentacaoService';
import React from 'react';
import { VendedorMovimentacaoDetalhesModal } from './DetalhesModal';

export type FichaVendedorMovimentacaoTableProps = {
    isLoading: boolean
    data: IData<IVendedorMovimentacao, IVendedorMovimentacaoFilter>
    vendedor: IVendedor
    tableContainerProps?: TableContainerProps
    menu: IMenu
}

export function FichaVendedorMovimentacaoTable ({isLoading, data, tableContainerProps, vendedor, menu}: FichaVendedorMovimentacaoTableProps) {
    const formatter = useFormatter();
    const vendedorMovimentacaoTipoColor = useVendedorMovimentacaoTipoColor();
    const vendedorMovimentacaoDetalhesModal = useModalWindow();

    return (
        <React.Fragment>
            <DataTable 
                isLoading={isLoading} 
                itemCount={data.itemsCount}
                tableContainerProps={tableContainerProps}
            >
                <TableHead>
                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="vendedorMovimentacaoId">ID</TableSortCell>
                        <TableSortCell fieldName="dataHora">Data/Hora</TableSortCell>
                        <TableSortCell fieldName="competencia">Competência</TableSortCell>
                        <TableSortCell fieldName="tipo">Tipo</TableSortCell>
                        <TableHeaderCellAction />
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((vendedorMovimentacao) => {
                            return (
                                <TableRow key={vendedorMovimentacao.vendedorMovimentacaoId}>
                                    <TableKeyCell><Anchor onClick={data.handleRowFocused(vendedorMovimentacao, vendedorMovimentacaoDetalhesModal.open)}>{vendedorMovimentacao.vendedorMovimentacaoId}</Anchor></TableKeyCell>
                                    <TableCell>{formatter.toDateTime(vendedorMovimentacao.dataHora)}</TableCell>
                                    <TableCell>{formatter.toCompetencia(vendedorMovimentacao.competencia)}</TableCell>
                                    
                                    <TableCell className={vendedorMovimentacaoTipoColor[vendedorMovimentacao.tipo.value]}>
                                        { vendedorMovimentacao.tipo.description }
                                    </TableCell>
                                    <TableCellAction onButtonClick={data.handleRowFocused(vendedorMovimentacao, menu.open)} />
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </DataTable>

            {
                data.focusedRow !== undefined && (
                    <VendedorMovimentacaoDetalhesModal 
                        vendedorMovimentacaoId={data.focusedRow.vendedorMovimentacaoId}
                        modal={vendedorMovimentacaoDetalhesModal}
                    />
                )
            }        
        </React.Fragment>
    )
}